import HomeIcon from "../assets/images/home.svg";
export default function Breadcumb({ breadcrumb, module }) {
  let breadcrumbList = breadcrumb.split("-");
  console.log("breadcrumb", breadcrumb);
  console.log("breadcrumbList", breadcrumbList);
  return (
    <nav className="navClass" aria-label="breadcrumb">
      <ol className="breadcrumb">
        {breadcrumbList.map((title, index) => {
          if (title == "Home")
            return (
              <li className="breadcrumb-item">
                <a href="javascript:void(0);">
                  <img src={HomeIcon} alt="home" />
                </a>
              </li>
            );
          else
            return (
              <li className="breadcrumb-item active" aria-current="page">
                {index == 1 ? <a href={`/${module}/list`}>{title}</a> : title}
              </li>
            );
        })}
      </ol>
    </nav>
  );
}
